import React, { useContext } from 'react'
import { UserContext } from '../../../App'

const Products = ({ seller, deliveryType, products }) => {
  const { user } = useContext(UserContext)
  return (
    <div className="shadow-lg p-10 w-full flex flex-col gap-5">
        <h2 className="text-sm md:text-base font-bold">Produktdetaljer</h2>
        <p className="text-sm underline">{seller._id === user._id ? (deliveryType === 3 ? "Køberen har købt følgende bøger" : "Pakken skal indeholde følgende bøger") : (deliveryType === 3 ? "Du skal afhente følgende bøger" : "Denne forsendelse indeholder følgende bøger")}</p>
        <table class="table-fixed w-full text-left hidden md:inline-table">
            <thead className="text-sm">
                <tr>
                <th className="pb-4 font-semibold">Titel</th>
                <th className="pb-4 px-5 font-semibold">Forfatter</th>
                <th className="pb-4 px-5 font-semibold">Udgave</th>
                <th className="pb-4 px-5 font-semibold">ISBN</th>
                <th className="text-end pb-4 font-semibold">Pris</th>
                </tr>
            </thead>
            <tbody className="text-sm xl:text-base">
                {products.map((product) => {
                    return (
                        <tr className="border-t hover:bg-neutral-100 cursor-pointer">
                            <td className="py-4 font-medium">{product.apiBook.title}</td>
                            <td className="py-4 px-5 truncate">{product.apiBook.director.map((dir) => dir['$']).join(', ')}</td>
                            <td className="py-4 px-5">{product.apiBook.version}</td>
                            <td className="py-4 px-5 truncate">{product.apiBook.isbn}</td>
                            <td className="text-end py-4 font-medium">{Number(product.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    </div>
  )
}

export default Products